import { Controller } from "@hotwired/stimulus"


export default class extends Controller {
  static values = {
    lat: Number,
    long: Number,
    zoom: Number
  }

  connect() {
    const googleTraffic = window.App?.GoogleTraffic
    if (!googleTraffic?.map?.render) return

    googleTraffic.map.render({
      lat: this.latValue,
      long: this.longValue,
      zoom: this.zoomValue
    })
  }
}
